import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl } from "@angular/forms";

@Component({
    selector: "[pcg-ng-postcode-filter]",
    templateUrl: "./postcode-filter.component.html"
})
export class PostcodeFilterComponent {
    public locationControl: FormControl<string> = null;
    public distanceControl: FormControl<number> = null;

    @Input("location")
    public set locationSetter(value: FormControl<string>) {
        this.locationControl = value;
    }

    @Input("distance")
    public set distanceSetter(value: FormControl<number>) {
        this.distanceControl = value;
    }

    @Output()
    public onSubmit = new EventEmitter();

    public get isSubmitDisabled(): boolean {
        return false; // (this.locationControl.value.length < 3);
    }

    public onSubmitClicked(): void {
        this.onSubmit.emit();
    }
}
